const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export type AppEnv = 'production' | 'staging' | 'development';

/** Pinned Connector UI bundle — must use production cloud APIs, not localhost dev routing. */
export function isPinnedLocalUiBundle(): boolean {
  if (typeof window === 'undefined') return false;
  const w = window as Window & { __MAESTRO_UI_BUNDLE_MODE__?: string };
  if (w.__MAESTRO_UI_BUNDLE_MODE__ === 'local') return true;
  const { protocol, hostname: host } = window.location;
  if (protocol === 'maestro-app:') return true;
  if (host === 'maestro-app.localhost') return true;
  return false;
}

/** Real Vite/dev server on http://localhost:<port> or http://127.0.0.1:<port>. */
export function isRealLocalDevServer(): boolean {
  if (typeof window === 'undefined') return false;
  const { protocol, hostname: host } = window.location;
  return (protocol === 'http:' || protocol === 'https:')
    && (host === 'localhost' || host === '127.0.0.1');
}

export const APP_ENV: AppEnv =
  isPinnedLocalUiBundle() ? 'production' :
  hostname.includes('staging') ? 'staging' :
  isRealLocalDevServer() ? 'development' :
  'production';

/**
 * Local dev only: `localStorage` key `MAESTRO_DEV_CLOUD` = `staging` (default) | `production`.
 * When `production`, localhost uses the same cloud API/WebSocket as production builds.
 *
 * April 2026: shim while api-staging was missing secrets/out of date — use `production` until
 * staging is repaired (see `00_Architecture/TECH_DEBT.md` items 2 and 7). Remove or narrow once
 * staging matches production.
 */
function readMaestroDevCloud(): 'staging' | 'production' {
  if (APP_ENV !== 'development' || typeof window === 'undefined') return 'staging';
  try {
    const raw = localStorage.getItem('MAESTRO_DEV_CLOUD');
    const v = typeof raw === 'string' ? raw.trim() : '';
    if (v === 'production') return 'production';
    return 'staging';
  } catch {
    return 'staging';
  }
}

const DEV_CLOUD = readMaestroDevCloud();

export const API_BASE =
  APP_ENV === 'development'
    ? DEV_CLOUD === 'production'
      ? 'https://api.maestroaudio.net'
      : 'https://api-staging.maestroaudio.net'
    : 'https://api.maestroaudio.net';

export const WS_BASE =
  APP_ENV === 'development'
    ? DEV_CLOUD === 'production'
      ? 'wss://api.maestroaudio.net'
      : 'wss://api-staging.maestroaudio.net'
    : 'wss://api.maestroaudio.net';

export const IS_BETA = APP_ENV !== 'production';

if (typeof window !== 'undefined' && APP_ENV === 'development') {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem('MAESTRO_DEV_CLOUD');
  } catch {
    /* ignore */
  }
  console.log('[Maestro dev cloud]', {
    api: API_BASE,
    ws: WS_BASE,
    MAESTRO_DEV_CLOUD: raw,
    resolved: DEV_CLOUD,
  });
}
